import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTachometerAlt, FaUsers, FaBlog, FaEnvelope, FaAddressCard } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../assets/images/logo.png"; // Adjust path based on your structure

const Sidebar = ({ setIsSidebarOpen }) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
    setIsSidebarOpen(!isOpen);
  };

  return (
    <div
      className={`d-flex flex-column bg-dark text-white vh-100 position-fixed p-3`}
      style={{
        width: isOpen ? "250px" : "80px",
        transition: "width 0.3s ease-in-out",
        overflowX: "hidden",
        top: 0,
        left: 0,
      }}
    >
      {/* Logo and Company Name */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center" style={{ overflow: "hidden" }}>
          <img
            src={logo}
            alt="Company Logo"
            style={{
              width: isOpen ? "40px" : "30px",
              height: isOpen ? "40px" : "30px",
              borderRadius: "50%", // Makes it round
              marginRight: isOpen ? "10px" : "0",
              transition: "all 0.3s ease",
              objectFit: "cover",
            }}
          />
          {isOpen && (
            <a
              style={{
                fontSize: "14px", // Smaller font
                whiteSpace: "nowrap", // Prevent wrapping
                overflow: "hidden",
                textOverflow: "ellipsis", // Add "..." if it overflows
                maxWidth: "150px", // Prevent overflow from parent
                color: "white",
              }}
              href="https://biopharmacieaa.com/" target="_blank">
              Biopharmacieaa
            </a>
          )}
        </div>
        <button
          className="btn btn-outline-light"
          onClick={toggleSidebar}
          style={{ padding: "5px 10px" }}
        >
          <FaBars size={20} />
        </button>
      </div>


      {/* Sidebar Items */}
      <ul className="nav flex-column">
        <li className="nav-item">
          <Link to="/admin/dashboard" className="nav-link text-white d-flex align-items-center">
            <FaTachometerAlt size={20} className="me-2" />
            {isOpen && "Dashboard"}
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/admin/users" className="nav-link text-white d-flex align-items-center">
            <FaUsers size={20} className="me-2" />
            {isOpen && "Manage Users"}
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/admin/AdminBlogs" className="nav-link text-white d-flex align-items-center">
            <FaBlog size={20} className="me-2" />
            {isOpen && "Blogs"}
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/admin/contact" className="nav-link text-white d-flex align-items-center">
            <FaEnvelope size={20} className="me-2" />
            {isOpen && "Contact Us"}
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/admin/contact-info"
            className="nav-link text-white d-flex align-items-center"
          >
            <FaAddressCard size={20} className="me-2" />
            {isOpen && "Contact Info"}
          </Link>
        </li>

      </ul>
    </div>
  );
};

export default Sidebar;
